export const SEEDBED_QUALITY = {
  GOOD: 'GOOD',
  NORMAL: 'NORMAL',
  BAD: 'BAD',
};

export type SeedbedQuality = (typeof SEEDBED_QUALITY)[keyof typeof SEEDBED_QUALITY];

export const allSeedbedQualities = () => {
  return [SEEDBED_QUALITY.GOOD, SEEDBED_QUALITY.NORMAL, SEEDBED_QUALITY.BAD];
};
